import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import {
 AssetSummaryDto, AssetSummaryDtoV2, type MonitorSummaryDto,
} from '@/api';
import { getProviderIconSrc } from '@/utils/provider-icons';
import QualityStatus from '@/components/quality-status/Quality-Status.vue';
import SIcon from '@/components/SIcon.vue';
import SEllipsisTooltip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';

interface AssetPreviewCardProps {
  entity: AssetSummaryDto | MonitorSummaryDto | AssetSummaryDtoV2;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Asset-Preview-Card',
  props: {
  entity: null
},
  setup(__props) {

const props = __props;


const icon = _computed(() => {
  switch (props.entity.displayedType) {
    case AssetSummaryDto.displayedType.DASHBOARD:
    case AssetSummaryDto.displayedType.REPORT:
    case AssetSummaryDto.displayedType.ANALYSIS:
    case AssetSummaryDto.displayedType.APP:
      return 'icon-chart-multiple';
    case AssetSummaryDto.displayedType.MODEL:
    case AssetSummaryDto.displayedType.DAG:
    case AssetSummaryDto.displayedType.ORCHESTRATOR:
    case AssetSummaryDto.displayedType.PIPELINE:
    case AssetSummaryDto.displayedType.CONNECTOR:
      return 'icon-pipeline-orchestrator';
    case AssetSummaryDto.displayedType.VIEW:
    case AssetSummaryDto.displayedType.MATERIALIZED_VIEW:
    case AssetSummaryDto.displayedType.VIEW_REF:
      return 'icon-data-view';
    case AssetSummaryDto.displayedType.DYNAMIC_TABLE:
    case AssetSummaryDto.displayedType.TABLE:
    case AssetSummaryDto.displayedType.SNOWFLAKE_STREAM:
    case AssetSummaryDto.displayedType.DATASET_REF:
    case AssetSummaryDto.displayedType.TABLE_REF:
    case AssetSummaryDto.displayedType.DATASET:
    case AssetSummaryDto.displayedType.NODE:
    case AssetSummaryDto.displayedType.STREAMING_TABLE:
    case AssetSummaryDto.displayedType.DROPPED_TABLE:
    case AssetSummaryDto.displayedType.TEMP_TABLE:
    case AssetSummaryDto.displayedType.EPHEMERAL_REF:
      return 'icon-data-table';
    case AssetSummaryDto.displayedType.EXTERNAL_TABLE:
      return 'icon-data-table-external';
    case AssetSummaryDto.displayedType.ML_MODEL:
      return 'icon-brain-circuit';
    default:
      return 'icon-shapes';
  }
});
const source = _computed(() => props.entity.lineagePlatformLabel);
const type = _computed(() => {
  if (props.entity.displayedType === AssetSummaryDto.displayedType.NONE) {
    return props.entity.displayedTypeLabel;
  }
  return props.entity.displayedType;
});
const imgsrc = _computed(() => (props.entity.lineagePlatform ? getProviderIconSrc(props.entity.lineagePlatform) : ''));
const alt = _computed(() => props.entity.lineagePlatform || '');
const name = _computed(() => props.entity.name || 'Unnamed Asset');
const hasHealthStatus = _computed(() => !!('healthStatus' in props.entity));
const healthStatus = _computed(() => {
  const entity = props.entity as AssetSummaryDtoV2;
  return entity.healthStatus;
});
const missingSince = _computed(() => {
  const entity = props.entity as AssetSummaryDtoV2;
  return entity.missingSince;
});
const scheduledDeletionDate = _computed(() => {
  const entity = props.entity as AssetSummaryDtoV2;
  return entity.scheduledDeletionDate;
});
const hasDeclaredSource = _computed(() => !!('declaredSource' in props.entity));
const isDeclaredSource = _computed(() => {
  if (!hasDeclaredSource.value) {
    return false;
  }
  const entity = props.entity as AssetSummaryDtoV2;
  return entity.declaredSource;
});
const hasSourceName = _computed(() => !!('sourceName' in props.entity));
const sourceName = _computed(() => {
  if (!hasSourceName.value) {
    return '';
  }
  const entity = props.entity as AssetSummaryDtoV2;
  return entity.sourceName;
});
const hasAssetType = _computed(() => !!('assetType' in props.entity));
const isDeclaredAsset = _computed(() => {
  if (!hasAssetType.value) {
    return false;
  }
  const entity = props.entity as AssetSummaryDtoV2;
  return entity.displayedType === AssetSummaryDto.displayedType.DECLARED_ASSET;
});


return { __sfc: true,props, icon, source, type, imgsrc, alt, name, hasHealthStatus, healthStatus, missingSince, scheduledDeletionDate, hasDeclaredSource, isDeclaredSource, hasSourceName, sourceName, hasAssetType, isDeclaredAsset, _computed, AssetSummaryDto, AssetSummaryDtoV2, getProviderIconSrc, QualityStatus, SIcon, SEllipsisTooltip }
}

})